module.exports = __webpack_public_path__ + "h5/img/news.f370b3a1.png";